import createReducer from '../../utils/createReducer';
import * as constants from './constants';

const initialState = {
  isFetching: false,
  errorMessage: null,
  link: null,
  campaign: null,
};

export default createReducer(initialState, {
  [constants.GET_CAMPAIGN_REQUEST](state, action) {
    const { isFetching } = action;
    return Object.assign({}, state, {
      isFetching,
    });
  },

  [constants.GET_CAMPAIGN_FAILURE](state, action) {
    const { isFetching, errorMessage } = action;
    return Object.assign({}, state, {
      isFetching,
      errorMessage,
    });
  },

  [constants.GET_CAMPAIGN_SUCCESS](state, action) {
    const { isFetching, errorMessage, campaign } = action;
    return Object.assign({}, state, {
      isFetching,
      errorMessage,
      campaign,
    });
  },

  [constants.GET_REFERRAL_LINK_REQUEST](state, action) {
    const { isFetching } = action;
    return Object.assign({}, state, {
      isFetching,
    });
  },

  [constants.GET_REFERRAL_LINK_FAILURE](state, action) {
    const { isFetching, errorMessage } = action;
    return Object.assign({}, state, {
      isFetching,
      errorMessage,
    });
  },

  [constants.GET_REFERRAL_LINK_SUCCESS](state, action) {
    const { isFetching, errorMessage, link } = action;
    return Object.assign({}, state, {
      isFetching,
      errorMessage,
      link,
    });
  },
});



// WEBPACK FOOTER //
// ./src/pages/DashboardPage/reducer.js